// This file is automatically generated by /scripts/git-version.ts
export const versions = {
  version: '0.0.0',
  revision: '1f1da3c31a73cc7aabd08d0223ba91107c7b62e9',
  branch: 'master',
};
